import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["details", "contact"]

  connect() {
    this.contactTarget.addEventListener("ajax:success", () => this.submitSuccess())
    this.contactTarget.addEventListener("ajax:error", () => this.submitError())
    this.formUrl = this.contactTarget.getAttribute("action")
  }

  details(event) {
    event.preventDefault()
    const source = event.currentTarget
    const target = this.detailsTarget
    this.monumentId = source.dataset.monumentId
    ga("send", "event", "Details", "view", "Monument", this.monumentId)

    const url = new URL(this.formUrl)
    url.searchParams.set("monument_id", this.monumentId)
    this.contactTarget.setAttribute("action", url.toString())

    const selectors = ["figure", "h3", ".description", ".location", ".price-discounted", ".price-regular", ".price-discount", ".order-entry-description"]
    selectors.forEach(selector => {
      const sourceElement = source.querySelector(selector)
      const targetElement = target.querySelector(selector)
      if (sourceElement && sourceElement.innerHTML !== "") {
        targetElement.innerHTML = sourceElement.innerHTML
        targetElement.style.display = ""
      } else {
        targetElement.innerHTML = ""
        targetElement.style.display = "none"
      }
    })
    this.element.classList.remove("show-contact")
    this.element.classList.add("show-info")
  }

  contact(event) {
    ga("send", "event", "Contact", "view", "Monument", this.monumentId)
    event.preventDefault()
    this.element.classList.remove("show-info")
    this.element.classList.add("show-contact")
  }

  close(event) {
    event.preventDefault()
    this.element.classList.remove("show-contact")
    this.element.classList.remove("show-info")
  }

  submitSuccess() {
    const formEvent = new CustomEvent("submit:success", {
      detail: { type: "success", message: "Votre message a bien été envoyé." }
    })
    ga("send", "event", "Contact", "submit", "Monument", this.monumentId)
    this.contactTarget.dispatchEvent(formEvent)
  }

  submitError() {
    const formEvent = new CustomEvent("submit:error", {
      detail: { type: "error", message: "Une erreur est survenue." }
    })
    ga("send", "event", "Contact", "error", "Monument", this.monumentId)
    this.contactTarget.dispatchEvent(formEvent)
  }
}
